import Vue from 'vue';
import Axios from 'axios';
import { getToken } from '@/common/jwt.service';
import { getAdminId } from '@/common/jwt.service';
import { BASE_PATH, SHOP_BASE_PATH } from '@/common/config';

const convertToFormData = (params) => {
    let form_data = new FormData();
    // form_data.set(params)
    for (var key in params) {
        form_data.append(key, params[key]);
    }

    return form_data;
};

const convertToFormDataKeepArray = (params) => {
    let form_data = new FormData();
    form_data = convertToFormDataKeepArrayHelper(params, form_data);

    return form_data;
};

const convertToFormDataKeepArrayHelper = (params, form_data) => {
    for (let key in params) {
        if (Array.isArray(params[key])) {
            for (let i = 0; i < params[key].length; ++i) {
                if (Array.isArray(params[key][i])) {
                    for (let j = 0; j < params[key][i].length; ++j) {
                        if (Array.isArray(params[key][i][j])) {
                            for (let e = 0; j < params[key][i][j].length; ++e) {
                                if (Array.isArray(params[key][i][j][e])) {
                                    for (
                                        let p = 0;
                                        j < params[key][i][j][e].length;
                                        ++p
                                    ) {
                                        if (
                                            Array.isArray(
                                                params[key][i][j][e][p]
                                            )
                                        ) {
                                            for (
                                                let c = 0;
                                                j <
                                                params[key][i][j][e][p].length;
                                                ++c
                                            ) {
                                                form_data.append(
                                                    key +
                                                        '[' +
                                                        i +
                                                        '][' +
                                                        j +
                                                        '][' +
                                                        e +
                                                        '][' +
                                                        p +
                                                        '][]',
                                                    params[key][i][j][e][p][c]
                                                );
                                            }
                                        } else {
                                            form_data.append(
                                                key +
                                                    '[' +
                                                    i +
                                                    '][' +
                                                    j +
                                                    '][' +
                                                    e +
                                                    '][]',
                                                params[key][i][j][e][p]
                                            );
                                        }
                                    }
                                } else {
                                    form_data.append(
                                        key + '[' + i + '][' + j + '][]',
                                        params[key][i][j][e]
                                    );
                                }
                            }
                        } else {
                            form_data.append(
                                key + '[' + i + '][]',
                                params[key][i][j]
                            );
                        }
                    }
                } else {
                    form_data.append(key + '[]', params[key][i]);
                }
            }
        } else {
            form_data.append(key, params[key]);
        }
    }

    return form_data;
};

const convertToFormDataForCollective = (params) => {
    const formData = new FormData();
    const entries = Object.entries(params); // returns array of object property as [key, value]
    // https://medium.com/front-end-weekly/3-things-you-didnt-know-about-the-foreach-loop-in-js-ff02cec465b1

    for (let i = 0; i < entries.length; i++) {
        // don't try to be smart by replacing it with entries.each, it has drawbacks
        const arKey = entries[i][0];
        let arVal = entries[i][1];
        if (typeof arVal === 'boolean') {
            arVal = arVal === true ? 1 : 0;
        }
        if (Array.isArray(arVal)) {
            if (arVal[0].isFile) {
                for (let z = 0; z < arVal.length; z++) {
                    formData.append(`${arKey}[]`, arVal[z]);
                }

                continue; // we don't need to append current element now, as its elements already appended
            } else if (arVal[0] instanceof Object) {
                for (let j = 0; j < arVal.length; j++) {
                    if (arVal[j] instanceof Object) {
                        // if first element is not file, we know its not files array
                        for (const prop in arVal[j]) {
                            if (
                                Object.prototype.hasOwnProperty.call(
                                    arVal[j],
                                    prop
                                )
                            ) {
                                // do stuff
                                if (!isNaN(Date.parse(arVal[j][prop]))) {
                                    // (new Date(fromDate)).toUTCString()
                                    formData.append(
                                        `${arKey}[${j}][${prop}]`,
                                        new Date(arVal[j][prop])
                                    );
                                } else {
                                    formData.append(
                                        `${arKey}[${j}][${prop}]`,
                                        arVal[j][prop]
                                    );
                                }
                            }
                        }
                    }
                }
                continue; // we don't need to append current element now, as its elements already appended
            } else {
                arVal = JSON.stringify(arVal);
            }
        }

        if (arVal === null) {
            continue;
        }
        formData.append(arKey, arVal);
    }
    return formData;
};

const ApiServiceInit = () => {
    Vue.prototype.$axios = Axios;
    Vue.prototype.$axios.defaults.baseURL = BASE_PATH;
    Vue.prototype.$axios.defaults.timeout = 120000;

    if (getAdminId()) {
        Vue.prototype.$axios.defaults.headers.common['admin-id'] = getAdminId();
    }
    if (getToken()) {
        Vue.prototype.$axios.defaults.headers.common['Authorization'] =
            'Bearer ' + getToken();
    }
};

const ShopApiServiceInit = () => {
    Vue.prototype.$shop_axios = Axios.create({
        baseURL: SHOP_BASE_PATH,
        timeout: 120000,
    });
    if (getAdminId()) {
        Vue.prototype.$shop_axios.defaults.headers.common['admin-id'] =
            getAdminId();
    }
    if (getToken()) {
        Vue.prototype.$shop_axios.defaults.headers.common['Authorization'] =
            'Bearer ' + getToken();
    }
};

const ApiUrl = {
    path(uri) {
        return BASE_PATH + '/' + uri;
    }
};

const ShopApiUrl = {
    path(url) {
        return SHOP_BASE_PATH + '/' + url;
    }
};

const vpnService = {
    fetch() {
        return ApiService.query('vpn');
    }
};

export {
    ApiServiceInit,
    ShopApiServiceInit,
    ApiUrl,
    ShopApiUrl,
    vpnService,
    convertToFormData,
    convertToFormDataKeepArray,
    convertToFormDataKeepArrayHelper,
    convertToFormDataForCollective
};

export * from './core.service';
export * from './shop.service';
